import { Scene } from '@/js/Scene.js';
import '@/css/style.css'
const scene = new Scene();
console.log(scene);